export default "__VITE_ASSET__8fb0949a__"